module.exports = __webpack_public_path__ + "img/DSP.620a1b15.svg";